import { ActionIcon, Menu, Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import type { GroupMenuItem } from '@dealstack/frontend/shared/components/ExpandablePersonCard/GroupHeader.types';

interface Props {
	menuItems: GroupMenuItem[];
	menuTestId?: string;
}

export const PersonCardMenu = ({ menuItems, menuTestId }: Props) => (
	<Menu withinPortal position="bottom-end" width="12.5rem">
		<Menu.Target>
			<ActionIcon
				variant="subtle"
				size="sm"
				data-testid={menuTestId}
				style={{ alignSelf: 'center', marginLeft: '0.5rem' }}
			>
				<Icon variant="more-v3" size="md" color={defaultTheme.v3.colors.black[0]} />
			</ActionIcon>
		</Menu.Target>
		<Menu.Dropdown p="0.25rem">
			{menuItems.map((item) => (
				<Menu.Item
					key={item.key}
					onClick={item.onClick}
					p="0.5rem"
					disabled={item.disabled}
					data-testid={item.testId}
				>
					<Text size="0.875rem" c="dark.9">
						{item.label}
					</Text>
				</Menu.Item>
			))}
		</Menu.Dropdown>
	</Menu>
);
